<template>
  <cargo-pop-select-input
    v-model="value"
    v-bind="params.selectProps"
    @visible-change="onVisibleChange"
  />
</template>

<script>
import Vue from 'vue'
import CargoPopSelectInput from '@/components/Cargo/Common/CargoPopSelectInput'
export default Vue.extend({
  name: 'CargoAgGridPopSelectInput',
  components: { CargoPopSelectInput },
  data() {
    return {
      value: ''
    }
  },
  created() {
    this.value = this.params.value
  },
  mounted() {
  },
  methods: {
    getValue() {
      return this.value
    },
    onBlur() {
      this.params.api.stopEditing()
    },
    onParentCallBack(params) {
      this.value = params.value
    },
    onVisibleChange(value) {
      if (!value) {
        this.params.api.stopEditing()
      }
    }
  }
})
</script>
